/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Check_In_Credit_RewardInputs */

const en_check_in_credit_reward = /** @type {(inputs: Check_In_Credit_RewardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.credits} credits`)
};

const es_check_in_credit_reward = /** @type {(inputs: Check_In_Credit_RewardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.credits} creditos`)
};

/**
* | output |
* | --- |
* | "+{credits} credits" |
*
* @param {Check_In_Credit_RewardInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_credit_reward = /** @type {((inputs: Check_In_Credit_RewardInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Credit_RewardInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_credit_reward(inputs)
	return es_check_in_credit_reward(inputs)
});